import React, { useState, useEffect } from 'react'
import AddVideoToPlaylistContent from '../playlistAdds/AddVideoToPlaylistContent'
import ShareContent from './ShareContent'
import plus from '../icons/Plus.svg'
import shareIcon from '../icons/shareIcon.svg'
import downArrowTeal from '../icons/DownArrowTeal.svg'
import Modal from '../Modal'
import { useNavigate } from 'react-router-dom'
import useWindowDimentions from '../hooks/useWindowDimentions'
import { useSelector } from 'react-redux'
import { stopAnalyze } from '../../actions/AnalyzeActions'

const VideoNameAndActions = ({video, handleRewind, videoInfoExpanded, setVideoInfoExpanded}) => {

    const [isActive, setIsActive] = useState(false)
    const [shareActive, setShareActive] = useState(false)
    const navigate = useNavigate()

    const {width, height} = useWindowDimentions()
    const isMobile = width < 992

    const [right, setRight] = useState(0)

    const [top, setTop] = useState(0)

    const [openedMembers, setOpenMembers] = useState(false)

    const [descriptionExpanded, setDescriptionExpanded] = useState(false)

    const DESKTOP_DESCRIPTION_LENGTH = 450

    const { end_watermark, end_footprint } = useSelector(state=>state.analyze_info)


    const addClickHandler = (e) => {
        if(width < 650 && e.clientX > width - 220){
            setRight(10)
        } else {
            setRight(width-e.clientX)
        }

        if(height - e.clientY > 250){
            setTop(e.clientY)
        } else {
            setTop(height-270)
        }
        setIsActive(true)
    }

    const shareClickHandler = (e) => {
        setRight(width-e.clientX+5)
        setTop(e.clientY-20)
        setShareActive(true)
    }

    useEffect(()=>{
        stopAnalyze()
    },[video])

  return(
    <div className='col-12 px-3'>
        <div className = "w-100 d-flex flex-column flex-md-row align-items-start pt-3">
            {
                video.title ?
                <div className = "w-100 position-relative text-white d-flex flex-wrap align-items-center">
                    <div className={isMobile ? "text-white pe-2" : "text-white fw-bold pe-2"} id="videoplayer-title">
                        {video.title}
                    </div>
                            {video.members?.map((member, index) => (
                                <div className={
                                    index < 2 ?
                                    "d-block fs-6 px-1 fw-normal fst-italic text-info member-item" :
                                    openedMembers ?
                                    "d-block px-1 fs-6 fw-normal fst-italic text-info member-item" :
                                    "d-none fs-6 px-1 fw-normal fst-italic text-info member-item"

                                }
                            key={index}
                            role='button'
                            title={member.title}
                            onClick={()=>navigate(`/filter_results/${member.id}!7`)}
                        >
                        {member.title}
                            </div>
                        ))}
                        {
                            !isMobile && video.members.length > 3 ? openedMembers ?
                                <div className='text-secondary text-decoration-underline'role = 'button' onClick={()=>setOpenMembers(false)}>
                                    see less
                                </div> :
                                <div className='text-secondary text-decoration-underline' role = 'button' onClick={()=>setOpenMembers(true)}>
                                    ...see more
                                </div> : ""
                        }
                        {
                            isMobile && !openedMembers &&
                            <img
                                src={downArrowTeal}
                                alt="toggle description"
                                role="button"
                                className="ms-2"
                                style={{
                                    height: "0.6rem",
                                    transform: "rotate(0deg)",
                                    transition: "transform 0.2s linear",
                                }}
                                onClick={()=>setOpenMembers(!openedMembers)}
                            />
                        }
                </div>: ""
              }
            <div className = "col-5 col-lg-1 col-md-3 px-0 px-lg-3 d-none d-md-flex justify-content-end align-items-center position-relative"
                style={{gap:"1rem"}}>

                <img className='me-3'
                    role = "button"
                    style={{width:"1.3rem"}}
                    onClick={(e)=>shareClickHandler(e)}
                    src = {shareIcon}
                    alt = "Share"/>

                    <img
                    role = "button"
                    style={{width:"1.3rem"}}
                    onClick = {(e)=>addClickHandler(e)}
                    src = {plus}
                    alt = "Add"/>

            </div>
        </div>
        {
            video.description ?
            <div className='w-100 text-white pt-2'>
                {
                    isMobile ?
                    (openedMembers &&
                        <div>
                            {video.description}
                            <img
                                src={downArrowTeal}
                                alt="toggle description"
                                role="button"
                                className="ms-2"
                                style={{
                                    height: "0.6rem",
                                    transform: "rotate(180deg)",
                                    transition: "transform 0.2s linear",
                                }}
                                onClick={()=>setOpenMembers(false)}
                            />
                        </div>
                    ) :
                    <>
                        {descriptionExpanded ? video.description : video.description.slice(0,DESKTOP_DESCRIPTION_LENGTH)}
                        {
                            video.description.length > DESKTOP_DESCRIPTION_LENGTH ?
                            <span
                                className = 'text-info  text-nowrap'
                                role = 'button'
                                style={{zIndex:"100"}}
                                onClick={()=>setDescriptionExpanded(!descriptionExpanded)}>{descriptionExpanded ? ' See Less' : ' ...See more'}</span> :""
                        }
                    </>
                }
            </div> : ""
        }
        {
            isMobile &&
            <div className='pt-1'>
                <span
                    role = 'button'
                    className = 'text-info text-nowrap'
                    onClick={()=>setVideoInfoExpanded(!videoInfoExpanded)}>{videoInfoExpanded ? 'Hide Analyze' : 'Show Analyze'}</span>
            </div>
        }
        {
            videoInfoExpanded &&
            <div className = "col-12 pt-2 d-flex flex-row justify-content-between justify-content-md-end pe-4 pe-lg-0">

                <div className='d-flex d-md-none justify-content-center pt-1 pb-1'
                    style={{width:"8.625rem"}}
                >
                    {
                        end_watermark && end_footprint ?
                        <div
                            role = "button"
                            id = ""
                            onClick={(e)=>{e.stopPropagation(); handleRewind()}}
                            className = "w-100 rounded-pill text-center bg-yellow analyze-toggle-pill"
                        >ANALYZE</div> :
                        <div
                            role = "button"
                            id = ""
                            onClick={()=>stopAnalyze()}
                            className = "w-100 rounded-pill text-center bg-yellow analyze-toggle-pill"
                        >STOP</div>
                    }
                </div>
                <div className = "col-5 col-lg-2 col-md-3 px-0 px-lg-3 d-flex d-md-none justify-content-end align-items-center position-relative"
                    style={{gap:"1rem"}}>

                    <img className='me-3'
                        role = "button"
                        style={{width:"1.3rem"}}
                        onClick={(e)=>shareClickHandler(e)}
                        src = {shareIcon}
                        alt = "Share"/>

                        <img
                        role = "button"
                        style={{width:"1.3rem"}}
                        onClick = {(e)=>addClickHandler(e)}
                        src = {plus}
                        alt = "Add"/>

            </div>
            </div>
        }
        <div className='pt-3 d-block d-md-none'>
            <div className=" processing-container">
                {
                    end_watermark && end_footprint ?
                    <></>:
                    <div className="processing-line"></div>
                }
            </div>
        </div>
        <Modal
                trigger = {isActive}
                setTrigger = {setIsActive}
                top = {top}
                right = {right}
                content = {
                    <AddVideoToPlaylistContent
                        setIsActive = {setIsActive}
                        video_list = {[video.id]}
                        index = {1}
                        video = {video}
                    />
                }
            />
            <Modal
                trigger = {shareActive}
                setTrigger = {setShareActive}
                top = {top}
                right = {right}
                content = {
                <ShareContent
                    setShareActive = {setShareActive}
                    video = {video}
                />
                }
            />
    </div>

  )
}

export default VideoNameAndActions;
